import { isProductRebondValid } from './productRebond';
import { CommandeLinePanier } from '../../types/commandeLine/commandeLine.def';

const isCommandEnabled = (commandeLines: CommandeLinePanier[]): boolean => {
  if (commandeLines.length === 0) return false;
  return isProductRebondValid(commandeLines);
};

export default isCommandEnabled;
